const gstPattern = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/i;

export const GstFormSchema = () => {
    return {
        gstNumber: {
            type: "text",
            label: "GSTIN number",
            validation: (value) => {
                if (value.trim() === "") return "GSTIN number is required";
                if (!gstPattern.test(value)) return "Invalid GSTIN format";
                return null; // valid
            },
        },
    };
};

export const InvoiceSettingFormSchema = () => {
    return {
        prefix: {
            type: "text",
            label: "Prefix",
            columns: {md: 6},
            validation: (value) => {
                if (value.trim() === "") return "Prefix is required";
                return null;
            },
        },
        year: {
            type: "text",
            label: "Year",
            columns: {md: 6},
            validation: (value) => {
                if (!value || value.toString().trim() === "") return "Year is required";
                return null;
            },
        },
        startSeq: {
            type: "text",
            label: "Start Sequence",
            columns: {md: 6},
            validation: (value) => {
                if (!value || value.toString().trim() === "") return "Start sequence is required";
                return null;
            },
        }
    };
};

export const OrderInvoiceSettingFormSchema = () => {
    return {
        prefix: {
            type: "text",
            label: "Prefix",
            columns: {md: 6},
            validation: (value) => {
                if (value.trim() === "") return "Prefix is required";
                return null;
            },
        },
        year: {
            type: "text",
            label: "Year",
            columns: {md: 6},
            validation: (value) => {
                if (!value || value.toString().trim() === "") return "Year is required";
                return null;
            },
        },
        startSeq: {
            type: "text",
            label: "Start Sequence",
            columns: {md: 6},
            validation: (value) => {
                if (!value || value.toString().trim() === "") return "Start sequence is required";
                return null;
            },
        }
    };
};

export const BankSettingFormSchema = (list) => {
    const {
        items: bankList,
        status: bankListStatus,
    } = list.bankList;

    return {
        accountNumber: {
            type: "select",
            label: "Primary Bank",
            columns: {md: 12},
            options: bankListStatus === "success" ? bankList : {},
            validation: (value) => {
                if (value === '') {
                    return 'Bank is required';
                }
                return null;
            }
        },
    };
};

export const AllSettingFormSchema = () => {
    return {
        enableDisable: {
            type: 'object',
            properties: {
                bankPrint: {
                    type: 'switch',
                    label: 'Enable Bank',
                    columns: {md: 12, lg: 6},
                },
                gstPrint: {
                    type: 'switch',
                    label: 'Enable GST',
                    columns: {md: 12, lg: 6},
                },
                sacCode: {
                    type: 'switch',
                    label: 'Enable SAC Code',
                    columns: {md: 12, lg: 6},
                },
            }
        },
    };
};


